// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CreateDealSteps, CustomerFormGroup, DealerFormGroup, DealTypeInputs } from '@interfaces/create-deal-inputs.interface';
import { TemplateGroup } from '@interfaces/document.interfaces';
import { TradeInVehicle, Vehicle } from '@interfaces/vehicle.interfaces';

@Component({
    selector: 'app-create-deal-summary-component',
    templateUrl: './create-deal-summary-component.component.html',
    styles: [
        `
            ::ng-deep .mat-form-field-appearance-fill.mat-form-field-disabled .mat-form-field-flex {
                background-color: white;
                border: 1px solid rgba(8, 66, 137, 0.4);
                color: #191919;
            }
            ::ng-deep .mat-select-disabled .mat-select-value {
                color: #191919;
            }
        `,
    ],
})
export class CreateDealSummaryComponentComponent implements OnInit {
    @Input() dealTypeSelections: DealTypeInputs;
    @Input() customerFormProperties: CustomerFormGroup;
    @Input() coBuyerFormProperties: CustomerFormGroup;
    @Input() dealerFormProperties: DealerFormGroup;
    @Input() templateGroupSelection: TemplateGroup;
    @Input() vehicleProperties: Vehicle;
    @Input() buyerFound: boolean;
    @Input() coBuyerFound: boolean;
    @Input() tradeInVehicle: TradeInVehicle;
    @Output() goToStep$ = new EventEmitter<CreateDealSteps>();
    createDealSteps = CreateDealSteps;
    // Allow us to keep a copy for masking purposes
    buyerForm: CustomerFormGroup;
    coBuyerForm: CustomerFormGroup;

    ngOnInit() {
        this.buyerForm = Object.assign({}, this.customerFormProperties);
        this.coBuyerForm = Object.assign({}, this.coBuyerFormProperties);

        if (this.buyerFound) {
            this.buyerForm.phone = `*** *** ${this.customerFormProperties.phone.substring(this.customerFormProperties.phone.length - 4)}`;
        }

        if (this.coBuyerFound) {
            this.coBuyerForm.phone = `*** *** ${this.coBuyerFormProperties.phone.substring(this.coBuyerFormProperties.phone.length - 4)}`;
        }
    }

    goToStep(step: CreateDealSteps) {
        this.goToStep$.next(step);
    }
}
